import { baseApi } from "./BaseApi";
import * as constants from "../assets/constants";

class ImageRotationApi extends baseApi {

    constructor() {
        super(constants.DEBUG ? constants.base_url_stage : constants.base_url_prod);
    }

    rotateImage = async (imageSrc, filename, direction = 'right', destination = 'monitoring') => {
        try {
            // Создаем canvas для поворота изображения
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            const img = new Image();
            
            return new Promise((resolve, reject) => {
                img.onload = async () => {
                    // Поворачиваем размеры для поворота на 90 градусов
                    canvas.width = img.height;
                    canvas.height = img.width;
                    
                    // Применяем поворот на 90 градусов в зависимости от направления
                    ctx.translate(canvas.width / 2, canvas.height / 2);
                    const rotationAngle = direction === 'left' ? -Math.PI / 2 : Math.PI / 2;
                    ctx.rotate(rotationAngle);
                    ctx.drawImage(img, -img.width / 2, -img.height / 2);
                    
                    // Конвертируем в dataURL как в TakeAPhoto
                    const rotatedDataUri = canvas.toDataURL('image/jpeg', 0.9);
                    
                    try {
                        // Загружаем повернутое изображение на сервер
                        const result = await this.uploadRotatedImage(rotatedDataUri, filename, destination);
                        resolve(result);
                    } catch (error) {
                        reject(error);
                    }
                };
                
                img.onerror = () => {
                    reject(new Error('Не удалось загрузить изображение'));
                };
                
                img.crossOrigin = 'anonymous';
                img.src = imageSrc;
            });
        } catch (error) {
            throw error;
        }
    }

    uploadRotatedImage = async (dataUri, filename, destination = 'monitoring') => {
        const url = `/?app=fileupload2&destination=${destination}&filename=${encodeURIComponent(filename)}`;
        
        const body = new FormData();
        body.append('image', dataUri);
        
        try {
            const response = await this.post(url, {
                image: dataUri
            });
            return response;
        } catch (error) {
            throw error;
        }
    }
}

export default new ImageRotationApi(); 